export var TOP_CITY_IDS;
(function (TOP_CITY_IDS) {
  TOP_CITY_IDS[TOP_CITY_IDS["ROMA"] = 58091] = "ROMA";
  TOP_CITY_IDS[TOP_CITY_IDS["MILANO"] = 15146] = "MILANO";
  TOP_CITY_IDS[TOP_CITY_IDS["PALERMO"] = 82053] = "PALERMO";
  TOP_CITY_IDS[TOP_CITY_IDS["TORINO"] = 1272] = "TORINO";
  TOP_CITY_IDS[TOP_CITY_IDS["GENOVA"] = 10025] = "GENOVA";
  TOP_CITY_IDS[TOP_CITY_IDS["NAPOLI"] = 63049] = "NAPOLI";
  TOP_CITY_IDS[TOP_CITY_IDS["BOLOGNA"] = 37006] = "BOLOGNA";
  TOP_CITY_IDS[TOP_CITY_IDS["FIRENZE"] = 48017] = "FIRENZE";
  TOP_CITY_IDS[TOP_CITY_IDS["CATANIA"] = 87015] = "CATANIA";
  TOP_CITY_IDS[TOP_CITY_IDS["BARI"] = 72006] = "BARI";
  TOP_CITY_IDS[TOP_CITY_IDS["MESSINA"] = 83048] = "MESSINA";
  TOP_CITY_IDS[TOP_CITY_IDS["CAGLIARI"] = 92009] = "CAGLIARI";
})(TOP_CITY_IDS || (TOP_CITY_IDS = {}));